<script setup>
import { ref, computed, watch } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';

const storeField = useFieldsStore();
const value = defineModel()
const { validation, isValid, isTouched, textError } = useValidation(value)
// const maxLength = 400;


const props = defineProps({
    stateKey: {
        type: String,
    },
    placeholder: {
        type: String,
    },
    maxLength: {
        type: Number
    }
})

const count = ref(props.maxLength);

watch( value, (newValue) => {
	count.value = props.maxLength - newValue.length;
});

const resizeMessage = (e) => {
	const textarea = e.target;
    textarea.style.minHeight = `auto`;
	const textareaHeight = textarea.scrollHeight;
	textarea.style.minHeight = `${textareaHeight}px`;
	textarea.style.transition = `min-height .2s linear`
}

</script>
<template>
    <label :class="['input']">
        <div class="input__holder --message none-scrollbar">
            <textarea 
                :class="['input__field none-scrollbar', isTouched && (isValid ? 'valid' : 'not-valid') ]" 
                autocomplete="on"
                :maxlength="maxLength"
                @input="(e) => {storeField.updateFields(stateKey, 'title', value), resizeMessage(e), validation(stateKey)}" 
                @blur="validation(stateKey)"
                v-model="value"
                :placeholder="placeholder"
                >                            
            </textarea>
        </div>
        <span class="input__title"><slot></slot></span>
        <span class="input__counter"><i>{{ count }}</i>/<i>{{ maxLength }}</i></span>       
        <Transition>
            <span v-if="count === 0" class="input__error">Не более {{ maxLength }} символов</span>
        </Transition>       
    </label>
</template>
<style lang='scss' scoped>
.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}
</style>